import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useHistory, useLocation } from "react-router-dom"
import Barcode from "react-barcode"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import moment from "moment"
import SweetAlert from "react-bootstrap-sweetalert"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

//empty state
import UgiftEmptyState from "./UgiftEmptyState"
import emptyImage from "assets/images/ugifts/icons/empty/empty_outlet.png"

// import images
import voucherbgImage from "assets/images/ugifts/dummyBanner/voucherbg.png"
import iconExpired from "assets/images/ugifts/icon_expired.png"
import iconVoucher from "assets/images/ugifts/icons/icon_voucher.png"
import barcode from "assets/images/ugifts/dummyBanner/barcode.png"
import qrcode from "assets/images/ugifts/dummyBanner/qrcode.png"
import { Button } from "@material-ui/core"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const VoucherDetails = props => {
  const query = useQuery()
  const history = useHistory()

  const [modal_tnc, setmodal_tnc] = useState(false)
  const [modal_howtoredeem, setmodal_howtoredeem] = useState(false)
  const [modal_available, setmodal_available] = useState(false)

  function tog_tnc() {
    setmodal_tnc(!modal_tnc)
    removeBodyCss()
  }

  function tog_howToRedeem() {
    setmodal_howtoredeem(!modal_howtoredeem)
    removeBodyCss()
  }

  function tog_available() {
    setmodal_available(!modal_available)
    removeBodyCss()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) {
      getVoucherList()
      console.log("use effect")
    }
  }, [token])

  const [voucherData, setVoucherData] = useState(null)
  const [productData, setProductData] = useState(null)
  const getVoucherList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_evoucher")
    urlencoded.append("order_product_id", query.get("id"))
    // urlencoded.append("filter_by_status", listType)
    // urlencoded.append("limit", 5)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request evoucher", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_EVOUCHER, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setVoucherData(postresponse.table)
      setProductData(postresponse)
    } else {
      // seterror_alert(true)
    }
  }

  const refreshEvoucher = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "refresh_evoucher")
    urlencoded.append("order_product_id", query.get("id"))
    // urlencoded.append("filter_by_status", listType)
    // urlencoded.append("limit", 5)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request refresh evoucher", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_EVOUCHER, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      getVoucherList()
    } else {
      // seterror_alert(true)
    }
  }

  const [confirm_alert, setconfirm_alert] = useState(false)
  const [redeem_alert, setredeem_alert] = useState(false)
  const [redeem_url, setredeem_url] = useState(null)
  const [markUsedId, setMarkUsedId] = useState(false)
  const markVoucherUse = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "mark_evoucher_used")
    urlencoded.append("member_id", uid)
    urlencoded.append("order_evoucher_id", markUsedId)
    // urlencoded.append("filter_by_status", listType)
    // urlencoded.append("limit", 5)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request mark used", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_EVOUCHER, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setVoucherData(postresponse.table)
      getVoucherList()
    } else {
      // seterror_alert(true)
    }
  }

  const handleCopy = input => {
    const textField = document.createElement("textarea")
    textField.innerText = input
    document.body.appendChild(textField)
    textField.select()
    document.execCommand("copy")
    textField.remove()
    // setShareCodeMessage("Copied")
  }

  const handleOpenLinkInNewTab = input => {
    window.open(input)
  }

  const isValidHttpUrl = string => {
    let url

    try {
      url = new URL(string)
    } catch (_) {
      return false
    }

    return true
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "56px",
                  // paddingBottom: "76px",
                  backgroundColor: "#009FE2",
                }}
              >
                {confirm_alert ? (
                  <SweetAlert
                    title={props.t(
                      "Are you sure you want to mark this voucher as used?"
                    )} //{props.t("Are you sure?")}
                    warning
                    showCancel
                    confirmBtnText={props.t("Mark as used")} //{props.t("Delete")}
                    confirmBtnBsStyle="primary"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => {
                      setconfirm_alert(false)
                      markVoucherUse()
                    }}
                    cancelBtnText={props.t("Cancel")}
                    onCancel={() => setconfirm_alert(false)}
                  >
                    {props.t("Confirmation")}
                  </SweetAlert>
                ) : null}
                {redeem_alert ? (
                  <SweetAlert
                    title={props.t("Redirect")} //{props.t("Are you sure?")}
                    info
                    showCancel
                    confirmBtnText={props.t("Ok")} //{props.t("Delete")}
                    confirmBtnBsStyle="primary"
                    // cancelBtnBsStyle="danger"
                    cancelBtnText={props.t("Close")}
                    onConfirm={() => {
                      setredeem_alert(false)
                      handleOpenLinkInNewTab(redeem_url)
                    }}
                    onCancel={() => setredeem_alert(false)}
                  >
                    {props.t(
                      "You are leaving Ugift and will be automatically redirected to an external website for voucher redemption."
                    )}
                  </SweetAlert>
                ) : null}
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/vouchers"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {props.t("Voucher")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            refreshEvoucher()
                          }}
                        >
                          <i className="bx bx-sync align-middle font-size-20 text-white" />
                        </Button>
                      </Col>
                    </Row>
                    {voucherData &&
                      voucherData.map((data, index) => (
                        <Card
                          style={{
                            maxWidth: "343px",
                            backgroundImage: `url(${voucherbgImage})`,
                            backgroundSize: "cover",
                            height: "515px",
                            backgroundColor: "transparent",
                          }}
                          className="mx-auto w-100 p-4 shadow-none"
                          key={`data-${index}`}
                        >
                          <Row className="">
                            <Col className="text-center px-3">
                              <Col xs="auto" className="mx-auto">
                                <img
                                  src={iconVoucher}
                                  alt=""
                                  style={{
                                    // position: "absolute",
                                    objectFit: "contain",
                                    width: "48px",
                                    maxHeight: "48px",
                                  }}
                                  // className="mx-auto my-3"
                                />
                              </Col>
                            </Col>
                          </Row>
                          <Row className="">
                            <Col className="text-center px-3">
                              <h5 className="font-size-20 text-dark">
                                {data.name}
                              </h5>
                            </Col>
                          </Row>
                          {data.evoucher_code_type == "qrcode" &&
                            moment().isBefore(
                              moment(data.expiry_date, "DD-MM-YYYY")
                            ) && (
                              <div>
                                <Row>
                                  <Col xs="auto" className="mx-auto">
                                    <img
                                      src={data.evoucher_code_image}
                                      alt=""
                                      style={{
                                        // position: "absolute",
                                        objectFit: "contain",
                                        width: "130px",
                                        maxHeight: "130px",
                                      }}
                                      // className="mx-auto my-3"
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  className="m-0 p-2"
                                  style={{
                                    // position: "absolute",
                                    // top: "140px",
                                    // width: "100%",
                                    left: "30px",
                                    right: "30px",
                                    border: "solid",
                                    borderColor: "#E3E3E3",
                                    borderWidth: "1px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <Col className="text-center px-3">
                                    <strong>
                                      <span className="font-size-20 text-dark">
                                        {data.evoucher_code}
                                      </span>
                                    </strong>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          {data.evoucher_code_type == "barcode" &&
                            moment().isBefore(
                              moment(data.expiry_date, "DD-MM-YYYY")
                            ) && (
                              // <Row>
                              //   <Col className="d-flex justify-content-center my-3">
                              //     <Barcode
                              //       value={data.evoucher_code}
                              //       width="2"
                              //       fontSize="14"
                              //     />
                              //   </Col>
                              // </Row>
                              <div>
                                <Row>
                                  <Col xs="auto" className="mt-4 mx-auto">
                                    <img
                                      src={data.evoucher_code_image}
                                      alt=""
                                      style={{
                                        // position: "absolute",
                                        objectFit: "contain",
                                        // width: "270px",
                                        maxHeight: "180px",
                                      }}
                                      className="my-3"
                                    />
                                  </Col>
                                </Row>
                                <Row
                                  className="m-0 p-2"
                                  style={{
                                    // position: "absolute",
                                    // top: "140px",
                                    // width: "100%",
                                    left: "30px",
                                    right: "30px",
                                    border: "solid",
                                    borderColor: "#E3E3E3",
                                    borderWidth: "1px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <Col className="text-center px-3">
                                    <strong>
                                      <span className="font-size-20 text-dark">
                                        {data.evoucher_code}
                                      </span>
                                    </strong>
                                  </Col>
                                </Row>
                              </div>
                            )}
                          {data.evoucher_code_type == "alphanumeric" &&
                            moment().isBefore(
                              moment(data.expiry_date, "DD-MM-YYYY")
                            ) &&
                            (isValidHttpUrl(data.evoucher_code) == true ? (
                              <div>
                                <Row
                                  className="m-0 p-2"
                                  style={{
                                    position: "absolute",
                                    top: "140px",
                                    // width: "100%",
                                    left: "30px",
                                    right: "30px",
                                    border: "solid",
                                    borderColor: "#E3E3E3",
                                    borderWidth: "1px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <Col
                                    className="text-center px-2"
                                    style={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <strong>
                                      <i className="bx bx-link font-size-18 text-dark me-2" />
                                      <span className="font-size-18 text-dark">
                                        {data.evoucher_code}
                                      </span>
                                    </strong>
                                  </Col>
                                </Row>
                                <Row
                                  className="m-0"
                                  style={{
                                    position: "absolute",
                                    top: "198px",
                                    // width: "100%",
                                    left: "30px",
                                    right: "30px",
                                  }}
                                >
                                  <Col className="text-center px-3">
                                    <button
                                      className="btn btn-link font-size-15"
                                      onClick={() => {
                                        // handleOpenLinkInNewTab(
                                        //   data.evoucher_code
                                        // )
                                        setredeem_alert(true)
                                        setredeem_url(data.evoucher_code)
                                      }}
                                    >
                                      {props.t("Click to Redeem Gift Card")}
                                    </button>
                                  </Col>
                                </Row>
                              </div>
                            ) : (
                              <div>
                                <Row
                                  className="m-0 p-2"
                                  style={{
                                    position: "absolute",
                                    top: "140px",
                                    // width: "100%",
                                    left: "25px",
                                    right: "25px",
                                    border: "solid",
                                    borderColor: "#E3E3E3",
                                    borderWidth: "1px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  <Col className="text-center px-3">
                                    <strong>
                                      <span className="font-size-20 text-dark">
                                        {data.evoucher_code}
                                      </span>
                                    </strong>
                                  </Col>
                                </Row>
                                <Row
                                  className="m-0"
                                  style={{
                                    position: "absolute",
                                    top: "198px",
                                    // width: "100%",
                                    left: "30px",
                                    right: "30px",
                                  }}
                                >
                                  <Col className="text-center px-3">
                                    <button
                                      className="btn btn-link font-size-15"
                                      onClick={() => {
                                        handleCopy(data.evoucher_code)
                                      }}
                                    >
                                      {props.t("Copy code")}
                                    </button>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          {data.evoucher_code_type == "url" &&
                            moment().isBefore(
                              moment(data.expiry_date, "DD-MM-YYYY")
                            ) && (
                              <div>
                                <Row
                                  className="m-0"
                                  style={{
                                    position: "absolute",
                                    top: "160px",
                                    // width: "100%",
                                    left: "30px",
                                    right: "30px",
                                    border: "solid",
                                    borderColor: "#E3E3E3",
                                    borderWidth: "1px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {/* <Col
                                    className="text-center px-2"
                                    style={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    <strong>
                                      <i className="bx bx-link font-size-18 text-dark me-2" />
                                      <span className="font-size-18 text-dark">
                                        {data.evoucher_code}
                                      </span>
                                    </strong>
                                  </Col> */}
                                  {/* <Col className="text-center px-3">
                                    
                                </Col> */}
                                  <button
                                    className="btn btn-link font-size-15"
                                    onClick={() => {
                                      setredeem_alert(true)
                                      setredeem_url(data.evoucher_code)
                                    }}
                                  >
                                    {props.t("Click to Redeem Gift Card")}
                                  </button>
                                </Row>
                                {/* <Row
                                  className="m-0"
                                  style={{
                                    position: "absolute",
                                    top: "198px",
                                    // width: "100%",
                                    left: "30px",
                                    right: "30px",
                                  }}
                                >
                                  <Col className="text-center px-3">
                                    <button
                                      className="btn btn-link font-size-15"
                                      onClick={() => {
                                        handleOpenLinkInNewTab(
                                          data.evoucher_code
                                        )
                                      }}
                                    >
                                      {"Redeem"}
                                    </button>
                                  </Col>
                                </Row> */}
                              </div>
                            )}
                          {moment().isAfter(
                            moment(data.expiry_date, "DD-MM-YYYY")
                          ) && (
                            // <Row>
                            //   <Col className="d-flex justify-content-center my-3">
                            //     <Barcode
                            //       value={data.evoucher_code}
                            //       width="2"
                            //       fontSize="14"
                            //     />
                            //   </Col>
                            // </Row>
                            <div>
                              <Row>
                                <Col xs="auto" className="mt-4 mx-auto">
                                  <img
                                    src={iconExpired}
                                    alt=""
                                    style={{
                                      // position: "absolute",
                                      objectFit: "contain",
                                      width: "270px",
                                      // maxHeight: "180px",
                                    }}
                                    className="my-3"
                                  />
                                </Col>
                              </Row>
                            </div>
                          )}
                          <Row
                            className="w-100 g-0"
                            style={{
                              position: "absolute",
                              top: "300px",
                              left: 0,
                            }}
                          >
                            <Col className="text-center ps-4 pe-2">
                              <button
                                className="btn btn-primary waves-effect waves-light font-size-13 w-100"
                                onClick={tog_available}
                              >
                                {props.t("Available outlets")}
                              </button>
                            </Col>
                            <Col className="text-center ps-2 pe-4">
                              <button
                                // to="#"
                                className={
                                  data.status == "Used"
                                    ? "btn btn-light waves-effect waves-light font-size-13 w-100 text-muted"
                                    : "btn btn-primary waves-effect waves-light font-size-13 w-100"
                                }
                                // style={{ height: "42px" }}
                                onClick={() => {
                                  setMarkUsedId(data.id)
                                  setconfirm_alert(true)
                                }}
                                disabled={data.status == "Used"}
                              >
                                {data.status == "Used"
                                  ? moment(
                                      data.mark_used_date,
                                      "DD-MM-YYYY"
                                    ).format("[Used: ]D MMM YYYY")
                                  : props.t("Mark as used")}
                              </button>
                            </Col>
                          </Row>
                          <hr
                            className="m-0"
                            style={{
                              color: "#EAEAEA",
                              backgroundColor: "#CECECE",
                              height: "2px",
                              position: "absolute",
                              top: "356px",
                              // width: "100%",
                              left: "30px",
                              right: "30px",
                            }}
                          />
                          <Row
                            className="m-0"
                            style={{
                              position: "absolute",
                              top: "372px",
                              // width: "100%",
                              left: "30px",
                              right: "30px",
                            }}
                          >
                            <Col className="text-center px-3">
                              <span
                                className="font-size-12"
                                style={
                                  moment().isAfter(
                                    moment(data.expiry_date, "DD-MM-YYYY")
                                  )
                                    ? { color: "#E93C48" }
                                    : { color: "#4A4A4A" }
                                }
                              >
                                {moment().isAfter(
                                  moment(data.expiry_date, "DD-MM-YYYY")
                                )
                                  ? props.t("Expired on")
                                  : props.t("Redeem Before")}
                              </span>
                            </Col>
                          </Row>
                          <Row
                            className="m-0"
                            style={{
                              position: "absolute",
                              top: "395px",
                              // width: "100%",
                              left: "30px",
                              right: "30px",
                            }}
                          >
                            <Col className="text-center px-3">
                              <span
                                className="font-size-18"
                                style={
                                  moment().isAfter(
                                    moment(data.expiry_date, "DD-MM-YYYY")
                                  )
                                    ? { color: "#E93C48" }
                                    : { color: "#45A461" }
                                }
                              >
                                {moment(data.expiry_date, "DD-MM-YYYY").format(
                                  "D MMM YYYY"
                                )}
                              </span>
                            </Col>
                          </Row>
                          <hr
                            className="m-0"
                            style={{
                              color: "#EAEAEA",
                              backgroundColor: "#CECECE",
                              height: "2px",
                              position: "absolute",
                              top: "434px",
                              // width: "100%",
                              left: "30px",
                              right: "30px",
                            }}
                          />
                          <Row
                            className="m-0"
                            style={{
                              position: "absolute",
                              top: "450px",
                              // width: "100%",
                              left: "30px",
                              right: "30px",
                            }}
                          >
                            <Col className="text-center px-3">
                              <button
                                className="btn btn-link font-size-12 text-dark"
                                onClick={tog_howToRedeem}
                              >
                                {props.t("How to redeem")}
                              </button>
                            </Col>
                          </Row>
                          <Row
                            className="m-0"
                            style={{
                              position: "absolute",
                              top: "471px",
                              // width: "100%",
                              left: "30px",
                              right: "30px",
                            }}
                          >
                            <Col className="text-center px-3">
                              <button
                                className="btn btn-link font-size-12 text-dark"
                                onClick={tog_tnc}
                              >
                                {props.t("Terms & Conditions")}
                              </button>
                            </Col>
                          </Row>
                        </Card>
                      ))}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={modal_tnc}
        toggle={() => {
          tog_tnc()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {props.t("Terms & Conditions")}
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_tnc(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          className="modal-body"
          dangerouslySetInnerHTML={
            productData && {
              __html: productData.terms_and_conditions,
            }
          }
        ></div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_tnc()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
          {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
        </div>
      </Modal>
      <Modal
        isOpen={modal_howtoredeem}
        toggle={() => {
          tog_howToRedeem()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {props.t("How to redeem")}
          </h5>
          <button
            type="button"
            onClick={() => {
              tog_howToRedeem()
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          className="modal-body"
          dangerouslySetInnerHTML={
            productData && {
              __html: productData.redeem_howto,
            }
          }
        ></div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_howToRedeem()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
          {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
        </div>
      </Modal>
      <Modal
        isOpen={modal_available}
        toggle={() => {
          tog_available()
        }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            {"Available Outlet"}
          </h5>
          <button
            type="button"
            onClick={() => {
              setmodal_available(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          {productData &&
            productData.applicable_outlets &&
            productData.applicable_outlets.map((outlet, index) => (
              <div>
                <Row className="mb-2">
                  <Col>
                    <strong>
                      <span className="font-size-15">{outlet.outlet_name}</span>
                    </strong>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <span className="font-size-15">{outlet.address}</span>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <span className="font-size-15">{outlet.outlet_telno}</span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span className="font-size-15">{outlet.email}</span>
                  </Col>
                </Row>
                <hr
                  style={{
                    color: "#EAEAEA",
                    backgroundColor: "#EAEAEA",
                    height: "2px",
                  }}
                />
              </div>
            ))}
          {productData &&
            productData.applicable_outlets &&
            productData.applicable_outlets.length == 0 && (
              <UgiftEmptyState
                image={emptyImage}
                title={props.t("No outlets available")}
                link={null}
                linkText=""
              />
            )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              tog_available()
            }}
            className="btn btn-secondary waves-effect"
            data-dismiss="modal"
          >
            {props.t("Close")}
          </button>
          {/* <button
            type="button"
            className="btn btn-primary waves-effect waves-light"
          >
            Save changes
          </button> */}
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default withTranslation()(VoucherDetails)

VoucherDetails.propTypes = {
  t: PropTypes.any,
}
